export const PAY_TYPE = {
  availableCard: 'AVAILABLE_CARD',
  newCard: 'NEW_CARD'
} as const;

export const PAY_BLOCK_ERROR = {
  jpCardIssued: 'PAYMENT_BLOCK_JP_CARD_ISSUED',
  nonJpCardIssued: 'PAYMENT_BLOCK_NON_JP_CARD_ISSUED'
} as const;

export const MAX_CARD_COUNT = 5;
export const POST_MESSAGE_EVENT = 'message';
export const PAY_RESULT_TYPE = 'tds_result';

export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export const INTERVAL_DURATION = 1_000;
export const COUNTDOWN = 500;

export const PAY_POLLING_INTERVAL = 3_000;
export const MAX_POLLING_COUNT = 20;

export const ACCESS_TOKEN_KEY = 'access_token';
